import ContentCopy from "@mui/icons-material/ContentCopy";
import { useIntl } from "react-intl";
import { Link } from "react-router";

import { IconButton } from "@citrine/atoms/icon-button";

import { makeSvgIcon } from "./svg-icon";

export const CopyIcon = makeSvgIcon(
  ContentCopy,
  (theme) => theme.palette.grey.A700
);

export function CopyLink({
  to,
  size = "small",
}: {
  to: string;
  size?: "small" | "medium";
}) {
  const { formatMessage } = useIntl();

  return (
    <Link to={to}>
      <IconButton size={size} tooltip={formatMessage({ id: "Copy" })}>
        <CopyIcon fontSize={size} />
      </IconButton>
    </Link>
  );
}

export default CopyIcon;
